import React, {useState} from 'react';
import TableReport from "../../../common/table/table";
import MessageEmptyData from "../../../common/messageEmptyData";
import EquipmentServicesTable from './equipmentServicesTable';
import ModalSendEquipmentServiceEmail from './modalSendEquipmentServiceEmail';

/**
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const EquipmentServicesBody = (prop) => {
    const {filters, setFilters, tableData, setSelectedRow, selectedRow} = prop;
    const [sendReportModal, setSendReportModal] = useState({isOpen: false});

    if (!filters.isSubmitted) {
        return null;
    }

    if (tableData.length === 0) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={
                    EquipmentServicesTable(
                        setFilters, setSelectedRow, setSendReportModal
                    )
                }
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'equipment_services'}
                withGlobalSearch={true}
                scrollable={true}
            />
            <ModalSendEquipmentServiceEmail
                modal={sendReportModal}
                setModal={setSendReportModal}
                selectedRow={selectedRow}
            />
        </div>
    );
}

export default EquipmentServicesBody;
